<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<div class="dialog-root">
  <div class="dialog-header">
    <h2 mat-dialog-title i18n>Reports</h2>
  </div>
  <div class="summary">
    <div class="summary-item">
      <span class="summary-label">Sample ID: </span>
      <span class="summary-value">{{ data.sampleId ?? '-' }}</span>
    </div>
    <div class="summary-item">
      <span class="summary-label">Sample Name: </span>
      <span class="summary-value">{{ data.sampleName ?? '-' }}</span>
    </div>
  </div>

  <ng-container *ngIf="loading; else reportsContent">
    <div class="loading-state">
      <div class="loader">
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <div class="loading-footer">
        <app-buttons
          name="Close"
          buttonType="mat-button"
          buttonStyle="btn-text"
          [isDisabled]="false"
          (buttonClickEvent)="close()">
        </app-buttons>
      </div>
    </div>
  </ng-container>
  <ng-template #reportsContent>
    <div class="filters">
      <app-dropdown class="filter-field" [label]="'File Type'" [options]="dropdownOptions"
        [selectedValue]="fileTypeCtl.value" [formControlObj]="fileTypeCtl"
        (selectedValueChange)="fileTypeCtl.setValue($event)">
      </app-dropdown>
      <app-table-search
        class="filter-field flex"
        (filterChanged)="onSearchChanged($event)">
      </app-table-search>
    </div>

    <div class="table-wrap">
      <table mat-table [dataSource]="dataSource" matSort matSortDisableClear="true" matSortActive="fileName" matSortDirection="asc">

        <!-- File Name -->
        <ng-container matColumnDef="fileName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="fileName">File Name</th>
          <td mat-cell *matCellDef="let r">{{ r.fileName }}</td>
        </ng-container>

        <!-- File Type -->
        <ng-container matColumnDef="fileType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="fileType">File Type</th>
          <td mat-cell *matCellDef="let r">{{ r.fileType }}</td>
        </ng-container>

        <!-- Size -->
        <ng-container matColumnDef="size">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="sizeBytes">Size</th>
          <td mat-cell *matCellDef="let r">{{ formatBytes(r.sizeBytes) }}</td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let r">
            <app-icons
              [icon]="'download'"
              [ariaLabel]="'Download'"
              [isDisabled]="!r.path"
              (iconClickEvent)="onDownloadIconClick(r)">
            </app-icons>
          </td>
        </ng-container>

        <!-- header & rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div class="dialog-footer">
      <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
      <app-buttons name="Close" buttonType="mat-button" buttonStyle="btn-text" [isDisabled]="false"
        (buttonClickEvent)="close()">
      </app-buttons>
    </div>
  </ng-template>
</div>